import API from '../api'
import getUrl from './paths'

export const fetchFinbudReport = (name, pan, organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.experianCreditReport, { name, pan, organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getOrganisationCreditScoreAndPdf = (pan, organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getOrganisationCreditScoreAndPdf, { pan, organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
